var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconUploadedFile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.608,
    height: 22.409,
    viewBox: "0 0 19.608 22.409",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_metro-file-text",
    "data-name": "Icon metro-file-text",
    d: "M23.183,6.941a19.846,19.846,0,0,0-1.908-2.182,19.848,19.848,0,0,0-2.182-1.908,3.49,3.49,0,0,0-1.99-.923H6.249A1.753,1.753,0,0,0,4.5,3.679V22.586a1.753,1.753,0,0,0,1.751,1.751H22.356a1.753,1.753,0,0,0,1.751-1.751V8.931a3.49,3.49,0,0,0-.923-1.99Zm-2.9-1.192A19.1,19.1,0,0,1,21.873,7.53H18.5V4.161a19.082,19.082,0,0,1,1.781,1.588Zm2.421,16.837a.355.355,0,0,1-.35.35H6.249a.355.355,0,0,1-.35-.35V3.679a.355.355,0,0,1,.35-.35H17.1v4.9a.7.7,0,0,0,.7.7h4.9Zm-3.5-2.451H9.4a.7.7,0,1,1,0-1.4h9.8a.7.7,0,1,1,0,1.4Zm0-2.8H9.4a.7.7,0,1,1,0-1.4h9.8a.7.7,0,1,1,0,1.4Zm0-2.8H9.4a.7.7,0,0,1,0-1.4h9.8a.7.7,0,1,1,0,1.4Z",
    transform: "translate(-4.499 -1.928)",
    fill: "#16d696"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUploadedFile);
export default __webpack_public_path__ + "static/media/icon-uploaded-file.3f87b655d0b5db2e9e993cfa43066ebf.svg";
export { ForwardRef as ReactComponent };